<template>
    <div>
        <staff-group
            v-if="collaborators.length"
            :placeholder="$t.__('timeline.TimelineAuthorFilter.all_staff')"
            :collaborators="collaborators"
            @input="collaboratorsSelected"
            :selectedCollaborator="selected"
        />
        <span v-else>{{ $l10n.__('indisponible') | capitalize }}</span>
    </div>
</template>
<script>
import StaffGroup from 'vcomponents/inputs/custom/StaffGroup.vue';
import ActivitiesListings from 'vcomponents/listing/config/activitiesListings.js';

export default {
    props: {
        selected: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            collaborators: [],
        };
    },
    created() {
        this.fetch();
    },
    methods: {
        fetch() {
            let crmActivitiesListing = ActivitiesListings.find(
                (listing) => listing.id == 'crm-activity',
            );
            return ApiClient.get(crmActivitiesListing.metaUrl)
                .then((response) => {
                    let authors = response.data.authors;
                    let groups = [];
                    let noGroup = {
                        label: 'Autre',
                        value: '0',
                        children: [],
                    };
                    authors.map((author) => {
                        if (null == author.groups) {
                            noGroup.children.push({
                                label: author.firstname + ' ' + author.lastname,
                                value: author.id,
                            });
                        } else {
                            author.groups.map((group) => {
                                if (undefined == groups.find((one) => one.value == group.id)) {
                                    groups.push({
                                        label: group.name,
                                        value: group.id,
                                        children: [],
                                    });
                                }
                                if (undefined == groups.find((one) => one.value == group.id)) {
                                    return;
                                }
                                groups
                                    .find((one) => one.value == group.id)
                                    .children.push({
                                        label: author.firstname + ' ' + author.lastname,
                                        value: author.id,
                                    });
                            });
                        }
                    });
                    if (noGroup.children.length) {
                        groups.push(noGroup);
                    }
                    this.collaborators = groups;
                })
                .catch((_) =>
                    Push.error(
                        this.$l10n.__('Erreur lors de la récupération du filtre collaborateur'),
                    ),
                );
        },
        collaboratorsSelected(groups, collaborators) {
            this.$emit('input', 'authors', collaborators);
        },
    },
    components: {
        StaffGroup,
    },
};
</script>
